import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiComment } from '@wix/da-papi-types';
import CommentIcon from '@wix/da-ds/pkg/Icons/24x24/Comment';
import { NotificationQueueItem } from '../Notifications';
import Notification from '../Notifications/Notification';
import SystemNotification from '../SystemNotification';
import { BiData, CommentDeletionUndoBiEvent } from '@wix/da-bi/pkg/events';

export interface Props extends NotificationQueueItem {
  comment: PapiComment;
  insideModal: boolean;
  isCommentReduxReady?: boolean;
  onUnhide: (comment: PapiComment) => void;
}

export class CommentDeleteNotification extends React.Component<Props & WithTranslation> {
  render() {
    const { id, t, queueName, comment, insideModal, isCommentReduxReady } = this.props;
    return (
      <Notification
        id={id}
        queueName={queueName}
        cardComponent={SystemNotification}
        cardProps={{
          iconComponent: CommentIcon,
          actions: [
            {
              type: 'negative',
              label: t('comment.action.delete.undo'),
              onClick: this.onUndo,
              disabled: !isCommentReduxReady,
              biData: BiData<CommentDeletionUndoBiEvent>({
                evid: 188,
                commenterid: comment.user?.useridUuid,
                commentid: comment.commentId,
                itemid: comment.itemId,
                typeid: comment.typeId,
                is_comment_thread: insideModal ? 1 : 0,
              }),
            },
          ],
        }}
      >
        {t('comment.info.deleted')}
      </Notification>
    );
  }

  onUndo = () => {
    this.props.onUnhide(this.props.comment);
  };
}

export default withTranslation()(CommentDeleteNotification) as React.ComponentType<Props>;
